import { useCallback, useRef, useState } from "react";
import { ReactComponent as ArrowNext } from "assets/icons/arrow-next.svg";
import {
  FlyoutContainer,
  FlyoutPanel,
  FlyoutSubItem,
  FlyoutTrigger,
} from "./flyoutMenuItem.styles";

export interface FlyoutMenuItemOption {
  label: string;
  onClick: () => void;
}

interface FlyoutMenuItemProps {
  label: string;
  items: FlyoutMenuItemOption[];
}

export function FlyoutMenuItem({ label, items }: FlyoutMenuItemProps) {
  const [open, setOpen] = useState(false);
  const [openLeft, setOpenLeft] = useState(false);
  const containerRef = useRef<HTMLLIElement>(null);
  const closeTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const openPanel = useCallback(() => {
    if (closeTimerRef.current) clearTimeout(closeTimerRef.current);
    if (containerRef.current) {
      const rect = containerRef.current.getBoundingClientRect();
      setOpenLeft(window.innerWidth - rect.right < 200);
    }
    setOpen(true);
  }, []);

  const scheduleClose = useCallback(() => {
    closeTimerRef.current = setTimeout(() => setOpen(false), 150);
  }, []);

  return (
    <FlyoutContainer
      ref={containerRef}
      onMouseEnter={openPanel}
      onMouseLeave={scheduleClose}
    >
      <FlyoutTrigger>
        {label}
        <ArrowNext />
      </FlyoutTrigger>
      {open && (
        <FlyoutPanel
          openLeft={openLeft}
          onMouseEnter={openPanel}
          onMouseLeave={scheduleClose}
        >
          {items.map((item) => (
            <FlyoutSubItem key={item.label} onClick={item.onClick}>
              {item.label}
            </FlyoutSubItem>
          ))}
        </FlyoutPanel>
      )}
    </FlyoutContainer>
  );
}
